export default "__VITE_ASSET__CY_Hbfxs__"